import * as React from "react";
const Analytics = (props) => (
  <svg
    width={34}
    height={33}
    viewBox="0 0 34 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_di_6515_2851)">
      <g clipPath="url(#clip0_6515_2851)">
        <rect x={1} width={32} height={32} rx={10} fill="#27272A" />
        <g clipPath="url(#clip1_6515_2851)" filter="url(#filter1_dd_6515_2851)">
          <path
            d="M9.80039 23.9807C9.58822 23.9807 9.38473 23.8964 9.23471 23.7464C9.08468 23.5964 9.00039 23.3929 9.00039 23.1807V6.3999H7.40039V23.1807C7.40039 23.8172 7.65325 24.4277 8.10333 24.8778C8.55342 25.3278 9.16387 25.5807 9.80039 25.5807H26.6004V23.9807H9.80039Z"
            fill="url(#paint0_linear_6515_2851)"
          />
          <path
            d="M13.0004 16H11.4004V21.6H13.0004V16Z"
            fill="url(#paint1_linear_6515_2851)"
          />
          <path
            d="M17.0004 14.3999H15.4004V21.5999H17.0004V14.3999Z"
            fill="url(#paint2_linear_6515_2851)"
          />
          <path
            d="M21.0004 16.7998H19.4004V21.5998H21.0004V16.7998Z"
            fill="url(#paint3_linear_6515_2851)"
          />
          <path
            d="M25.0004 13.5999H23.4004V21.5999H25.0004V13.5999Z"
            fill="url(#paint4_linear_6515_2851)"
          />
          <path
            d="M16.2004 9.93108L20.2004 13.9311L26.366 7.76548L25.2348 6.63428L20.2004 11.6687L16.2004 7.66868L11.6348 12.2343L12.766 13.3655L16.2004 9.93108Z"
            fill="url(#paint5_linear_6515_2851)"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="filter0_di_6515_2851"
        x={0.5}
        y={0}
        width={33}
        height={33}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={0.5} />
        <feGaussianBlur stdDeviation={0.25} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6515_2851"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_6515_2851"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={0.5} />
        <feGaussianBlur stdDeviation={0.25} />
        <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_6515_2851"
        />
      </filter>
      <filter
        id="filter1_dd_6515_2851"
        x={-22.5996}
        y={-19.7016}
        width={79.1992}
        height={79.2}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={10} />
        <feGaussianBlur stdDeviation={10} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.118924 0 0 0 0 0.158031 0 0 0 0 0.570833 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6515_2851"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={3.89851} />
        <feGaussianBlur stdDeviation={15} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_6515_2851"
          result="effect2_dropShadow_6515_2851"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_6515_2851"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_6515_2851"
        x1={7.25204}
        y1={2.45888}
        x2={21.1708}
        y2={22.8808}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="white" stopOpacity={0.65} />
      </linearGradient>
      <linearGradient
        id="paint1_linear_6515_2851"
        x1={11.388}
        y1={14.8494}
        x2={14.4992}
        y2={16.1523}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="white" stopOpacity={0.65} />
      </linearGradient>
      <linearGradient
        id="paint2_linear_6515_2851"
        x1={15.388}
        y1={12.9205}
        x2={18.6941}
        y2={13.9974}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="white" stopOpacity={0.65} />
      </linearGradient>
      <linearGradient
        id="paint3_linear_6515_2851"
        x1={19.388}
        y1={15.8136}
        x2={22.3402}
        y2={17.2559}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="white" stopOpacity={0.65} />
      </linearGradient>
      <linearGradient
        id="paint4_linear_6515_2851"
        x1={23.388}
        y1={11.9561}
        x2={26.7555}
        y2={12.9433}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="white" stopOpacity={0.65} />
      </linearGradient>
      <linearGradient
        id="paint5_linear_6515_2851"
        x1={11.5209}
        y1={5.13502}
        x2={14.9718}
        y2={15.3467}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="white" stopOpacity={0.65} />
      </linearGradient>
      <clipPath id="clip0_6515_2851">
        <rect x={1} width={32} height={32} rx={10} fill="white" />
      </clipPath>
      <clipPath id="clip1_6515_2851">
        <rect
          width={19.2}
          height={19.2}
          fill="white"
          transform="translate(7.40039 6.3999)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default Analytics;
